export const NAME = 'BOARD';
export const SET_BOARDID= `${NAME}/SET_BOARDID`;
export const NEXT_PAGE= `${NAME}/NEXT_PAGE`;
export const GET_BOARDDATA= `${NAME}/GET_BOARDDATA`;
export const SET_IMAGE= `${NAME}/SET_IMAGE`;
export const DELETE_BOARD=`${NAME}/DELETE_BOARD`;
export const CLEAR_BOARD=`${NAME}/CLEAR_BOARD`;
export const CLEAR_IMAGE=`${NAME}/CLEAR_IMAGE`;
export const GET_BOARDDATA_SUCCESS= `${NAME}/GET_BOARDDATA_SUCCESS`;
export const GET_COMMENT= `${NAME}/GET_COMMENT`;

export function setBoardId(id) {
  return {
    type: SET_BOARDID,
    id,
  };
}
export function clearBoard() {
  return {
    type: CLEAR_BOARD,
  };
}
export function clearImage() {
  return {
    type: CLEAR_IMAGE,
  };
}

export function deleteBoard() {
  return {
    type: DELETE_BOARD,
  };
}
export function setImageurl(image) {
  return {
    type: SET_IMAGE,
    image,
  };
}

export function getBoardData(data) {

  return {
    type: GET_BOARDDATA,
    data,
  };
}

export function getBoardDataSuccess(data) {
  return {
    type: GET_BOARDDATA_SUCCESS,
    data,
  };
}

export function getCommentData(data) {

  return {
    type: GET_COMMENT,
    data,
  };
}

export function nextPage() {

  return {
    type: NEXT_PAGE,
  };
}



// WEBPACK FOOTER //
// ./src/redux/board/actions.js